import React from 'react';

import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';

const styles = () =>
  createStyles({
    root: {
      flexGrow: 1,
      zIndex: 1,
      position: 'relative',
      display: 'flex',
      margin: '0 auto',
      padding: '25px 50px',
      width: '100%',
      height: '100%',
    },
  });

type Props = WithStyles<typeof styles> & {
  children: any;
};

class PageContainer extends React.PureComponent<Props> {
  render() {
    const { classes } = this.props;
    return <div className={classes.root}>{this.props.children}</div>;
  }
}

export default withStyles(styles)(PageContainer);
